import React, { ReactElement } from "react";
import { useTranslation } from "next-i18next";
import { useAppContext } from "@kunduz/feature-website-context";
import { trackEvent } from "@kunduz/utility-analytics";
import styles from "./questionSideCta.module.scss";
import type { QuestionIndexing } from "@kunduz/data-access-qi-api";
import { useStudentLimits } from "@kunduz/data-access-core-api";
import { Button, Text } from "@kunduz/ui-atoms";

export const GoUnlimitedCta = (props: Props): ReactElement => {
  const { t } = useTranslation("questionIndexing");
  const { student, localeInfo, kunduzApiToken } = useAppContext();
  const { studentLimits } = useStudentLimits(kunduzApiToken);

  function onCtaClick() {
    trackCtaClick();
  }

  function trackCtaClick() {
    const plan_type = !student.data?.primary_package
      ? "freemium"
      : student.data?.primary_package?.package.is_recurring
        ? "monthly"
        : "unlimited";

    trackEvent("Question Indexing See Plans Button Clicked", {
      course: props.question?.course?.slug,
      subject: props.question?.subject?.slug,
      page_slug: window.location.pathname,
      remaining_answer_credit: studentLimits?.questions?.remained,
      initial_answer_credit: studentLimits?.questions?.total,
      plan_type,
      type: "sidebar",
      persona: undefined,
    });
  }

  return (
    <div className={styles.goUnlimited}>
      <GoUnlimitedIcon />

      <div
        className={styles.title}
        dangerouslySetInnerHTML={{
          __html: t(
            "question_indexing_sidebar_component_purchase_plan_state_primary_proposition_text",
          ),
        }}
      />

      <p className={styles.desc}>
        {t(
          "question_indexing_sidebar_component_purchase_plan_state_secondary_proposition_text",
        )}
      </p>

      <ul className={styles.list}>
        <li>
          {t(
            "question_indexing_sidebar_component_purchase_plan_first_value_proposition_text",
          )}
        </li>
        <li>
          {" "}
          {t(
            "question_indexing_sidebar_component_purchase_plan_second_value_proposition_text",
          )}
        </li>
        <li>
          {" "}
          {t(
            "question_indexing_sidebar_component_purchase_plan_third_value_proposition_text",
          )}
        </li>
        <li>
          {" "}
          {t(
            "question_indexing_sidebar_component_purchase_plan_fourth_value_proposition_text",
          )}
        </li>
      </ul>

      <Button
        as={"a"}
        href={
          localeInfo?.locale?.iso.toLocaleLowerCase() == "tr"
            ? "/paketler"
            : "/plans"
        }
        variant="secondary"
        color="gray"
        size="xl"
      >
        <Text variant="textmd" weight="semibold">
          {" "}
          {t(
            "question_indexing_sidebar_component_purchase_plan_state_cta_label",
          )}
        </Text>
      </Button>
    </div>
  );
};

interface Props {
  question?: QuestionIndexing.TrQiQuestion;
}

function GoUnlimitedIcon() {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="45" height="45" rx="22.5" fill="white" />
      <path
        d="M24.7823 26.106C25.3607 26.8838 26.1001 27.5277 26.95 27.9937C27.7999 28.4597 28.7404 28.7369 29.7072 28.8063C31.3798 28.8063 32.9838 28.1419 34.1665 26.9592C35.3492 25.7766 36.0136 24.1725 36.0136 22.5C36.0136 20.8274 35.3492 19.2234 34.1665 18.0407C32.9838 16.858 31.3798 16.1936 29.7072 16.1936C25.2027 16.1936 22.5 22.5 22.5 22.5C22.5 22.5 19.7972 28.8063 15.2927 28.8063C13.6201 28.8063 12.0161 28.1419 10.8334 26.9592C9.65075 25.7766 8.98633 24.1725 8.98633 22.5C8.98633 20.8274 9.65075 19.2234 10.8334 18.0407C12.0161 16.858 13.6201 16.1936 15.2927 16.1936C16.2598 16.2641 17.2003 16.5423 18.0502 17.0091C18.9001 17.4759 19.6393 18.1204 20.2177 18.8987"
        fill="#01CCBC"
      />
      <path
        d="M24.7823 26.106C25.3607 26.8838 26.1001 27.5277 26.95 27.9937C27.7999 28.4597 28.7404 28.7369 29.7072 28.8063C31.3798 28.8063 32.9838 28.1419 34.1665 26.9592C35.3492 25.7766 36.0136 24.1725 36.0136 22.5C36.0136 20.8274 35.3492 19.2234 34.1665 18.0407C32.9838 16.858 31.3798 16.1936 29.7072 16.1936C25.2027 16.1936 22.5 22.5 22.5 22.5C22.5 22.5 19.7972 28.8063 15.2927 28.8063C13.6201 28.8063 12.0161 28.1419 10.8334 26.9592C9.65075 25.7766 8.98633 24.1725 8.98633 22.5C8.98633 20.8274 9.65075 19.2234 10.8334 18.0407C12.0161 16.858 13.6201 16.1936 15.2927 16.1936C16.2598 16.2641 17.2003 16.5423 18.0502 17.0091C18.9001 17.4759 19.6393 18.1204 20.2177 18.8987"
        stroke="#205EB8"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default GoUnlimitedCta;
